/**
 *
 * @param {number} maxVal Upper limit for values in map
 * @param {number} minVal Lower limit for values in map
 * @param {number} val Value for radius
 * @param {number} zoom Level of zoom in map
 * @param {boolean} isLegend Determines if the radius will be used for a legend circle or not.
 *
 * @returns Radius for circle
 */
export default function getRadius(maxVal, minVal, val, zoom, isLegend) {
  let radius;

  if (maxVal === minVal) {
    radius = 155000;
  } else {
    const maxRadius = 250000;
    const minRadius = 60000;

    const proportion = (val - minVal) / (maxVal - minVal);
    radius = proportion * (maxRadius - minRadius) + minRadius;
  }

  const radiusFactoringZoom = radius / (zoom - 2);

  if (isLegend) {
    const reducedRatio = radiusFactoringZoom / (10000 / (zoom - 3));

    return reducedRatio;
  }

  return radiusFactoringZoom;
}
